export default __webpack_public_path__ + "static/media/Telungana_1.4a1c4f4c.png";